import { Button, Flex } from 'antd';
import { ResultContainer } from './styles';
import ResultIcon from '../resultIcon';
import QueryDrawer from '../SuggestionDrawer';
import { CloseAction, QueryType, Routine } from '../../../../types';
import { useState } from 'react';
import RoutineDrawer from '../routineDrawer';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../../store';
import { closeDiagnoseConversation } from '../../../../slices/event';
import { EventInput1 } from '../../../../types/events';

const Result = ({ routine }: { routine?: Routine }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [causeDrawerVisible, setCauseDrawerVisible] = useState(false);
  const [showRoutineDrawer, setShowRoutineDrawer] = useState(false);

  const handleRoutineDrawerClose = (action?: CloseAction) => {
    setShowRoutineDrawer(false);
    if (action === CloseAction.BACK) {
      navigate(-1);
    }
  };

  return (
    <Flex gap={24} wrap="wrap">
      <ResultContainer>
        <ResultIcon />
        <p>Not the right cause</p>
        <Flex gap={24}>
          <Button
            ghost
            type="primary"
            onClick={() => {
              dispatch(closeDiagnoseConversation({ status: EventInput1.FAIL }));
              navigate(-1);
            }}
          >
            Close without cause
          </Button>
          <Button
            ghost
            type="primary"
            onClick={() => {
              setCauseDrawerVisible(true);
              dispatch(closeDiagnoseConversation({ status: EventInput1.FAIL }));
            }}
          >
            Suggest a cause
          </Button>
        </Flex>
      </ResultContainer>
      <ResultContainer>
        <ResultIcon right />
        <p>Found the right cause</p>
        <Button
          type="primary"
          disabled={!routine}
          onClick={() => setShowRoutineDrawer(true)}
        >
          Yes, go to routine
        </Button>
      </ResultContainer>
      <QueryDrawer
        visible={causeDrawerVisible}
        onClose={() => setCauseDrawerVisible(false)}
        onConfirm={() => setCauseDrawerVisible(false)}
        queryType={QueryType.CASUE}
      />
      <RoutineDrawer
        open={showRoutineDrawer}
        routine={routine as Routine}
        onClose={handleRoutineDrawerClose}
      />
    </Flex>
  );
};

export default Result;
